import { Check, Sparkles } from "lucide-react";

const PLANS = [
  { key: "six", items: ["base"], title: "Up to 6 family members", detail: "One storyteller, up to 12 recordings", price: "£9.99" },
  { key: "twelve", items: ["base", "extension"], title: "Up to 12 family members", detail: "One storyteller, up to 24 recordings", price: "£14.98" },
];
const PENCE = { base: 999, extension: 499, story: 999 };

export const giftItems = (plan, story) => [...PLANS.find((p) => p.key === plan).items, ...(story ? ["story"] : [])];
export const giftTotal = (items) => `£${(items.reduce((s, i) => s + PENCE[i], 0) / 100).toFixed(2)}`;
export const includesText = (items) => {
  const big = items.includes("extension");
  return `one storyteller, up to ${big ? 12 : 6} family members and up to ${big ? 24 : 12} recordings${items.includes("story") ? ", plus the AI-assisted narrated family story" : ""}`;
};

export function GiftOptions({ plan, setPlan, story, setStory, storyAvailable }) {
  return (
    <fieldset className="space-y-3" data-testid="gift-options">
      <legend className="eyebrow mb-2">Choose your gift</legend>
      {PLANS.map((p) => {
        const on = plan === p.key;
        return (
          <button type="button" key={p.key} onClick={() => setPlan(p.key)} aria-pressed={on} data-testid={`gift-option-${p.key}`}
            className={`w-full flex items-center gap-4 rounded-2xl border p-4 text-left transition-colors ${on ? "border-[#8B2CFF] bg-[#241634] shadow-[0_0_24px_rgba(139,44,255,0.25)]" : "border-[#33264A] bg-[#1A1222] hover:border-[#6B3FA8]"}`}>
            <span className={`h-6 w-6 shrink-0 rounded-full border flex items-center justify-center ${on ? "border-[#8B2CFF] bg-[#8B2CFF]" : "border-[#6B5A85]"}`}>{on && <Check className="h-4 w-4 text-white" aria-hidden="true" />}</span>
            <span className="flex-1"><span className="block text-[#EDE6F7] font-semibold text-lg">{p.title}</span><span className="block text-sm text-[#B9B3C8]">{p.detail}</span></span>
            <span className="text-xl text-[#EDE6F7] font-semibold">{p.price}</span>
          </button>
        );
      })}
      <label className={`flex items-center gap-4 rounded-2xl border p-4 ${storyAvailable ? "cursor-pointer border-[#33264A] bg-[#1A1222]" : "border-dashed border-[#33264A] bg-[#150F1C] opacity-80"}`} data-testid="gift-option-story">
        <input type="checkbox" disabled={!storyAvailable} checked={story} onChange={(e) => setStory(e.target.checked)} className="h-5 w-5 accent-[#8B2CFF]" data-testid="gift-story-checkbox" />
        <span className="flex-1 min-w-0">
          <span className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
            <span className="flex items-center gap-2 text-[#EDE6F7] font-semibold text-lg"><Sparkles className="h-4 w-4 shrink-0 text-[#B57BFF]" aria-hidden="true" />Add the narrated family story</span>
            {storyAvailable ? <span className="text-xl text-[#EDE6F7] font-semibold">+£9.99</span>
              : <span className="rounded-full border border-[#8B2CFF] px-3 py-1 text-xs tracking-widest text-[#C9B6FF] whitespace-nowrap" data-testid="gift-story-coming-soon">COMING SOON</span>}
          </span>
          <span className="block text-sm text-[#B9B3C8] mt-1">An AI-assisted story connecting everyone's memories, narrated for the family.</span>
        </span>
      </label>
    </fieldset>
  );
}
